import {ACCOUNT_SETTINGS_API_AUDIENCE} from "./securityContext";

const BASE_SCOPE = 'openid profile email';

export function getTokenOptions(scope) {
    if(!scope){
        return undefined;
    }
    return {
        authorizationParams: {
            audience: ACCOUNT_SETTINGS_API_AUDIENCE,
            scope: scope ? `${BASE_SCOPE} ${scope}` : BASE_SCOPE,
            connection: "customers-db",
        },
    };
}